import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { AimContextValue, AimEntityAttachment, initialAimContextValue } from './AimContextModels';
import { AimNote, PropertyPrice } from './AIMApi';
import { useForm } from '@mantine/form';

const AimContext = createContext<AimContextValue>(initialAimContextValue);

function AimProvider({ children }: { children: any }) {
    const [entityAttachments, setEntityAttachments] = useState<AimEntityAttachment>({
        entity: undefined,
        attachments: []
    });
  const [selectedPropertyPricesNewTransaction, setSelectedPropertyPricesNewTransaction] = useState<PropertyPrice[]>([]);
  const [selectedPropertyPricesEditTransaction, setSelectedPropertyPricesEditTransaction] = useState<PropertyPrice[]>([]);

  const handleSetSelectedPropertyPricesNewTransaction = (vals: PropertyPrice[]) => {
    setSelectedPropertyPricesNewTransaction(vals);
  }

  const handleSetSelectedPropertyPricesEditTransaction = (vals: PropertyPrice[]) => {
    setSelectedPropertyPricesEditTransaction(vals);
  }

    const [entityNotes, setEntityNotes] = useState<AimNote[]>([]);

    const clearEntityAttachments = () => {
        setEntityAttachments({
            entity: undefined,
            attachments: []
        });
    };

    const clearEntityNotes = () => {
        setEntityNotes([]);
    };
  console.log('aim provider');
  const phaseDataForm = useForm({
    initialValues: {
      crops: undefined,
      tillableAcres: undefined,
      irrigatedAcres: undefined,
      eitDate: undefined,
      askingPrice: undefined,
      pricePerTillableAcre: undefined,
      irr: undefined,
      coc: undefined,
      acreage: undefined,
      estCompletion: undefined,
      bidDate: undefined,
      closingDeadline: undefined,
      boardApprovalDeadline: undefined,
      dueDiligenceDeadline: undefined,
      phaseComplete: false,
      phaseCompletedOn: undefined,
    },
  });

    const handleSetPhaseDataInitialValues = (values: any) => {
      phaseDataForm.setValues({ ...values });
    }

    const contextInterface = useMemo(
        () => ({
            entityAttachments,
            setEntityAttachments,
            clearEntityAttachments,
            entityNotes,
            setEntityNotes,
            clearEntityNotes,
            selectedPropertyPricesNewTransaction,
            handleSetSelectedPropertyPricesNewTransaction,
            selectedPropertyPricesEditTransaction,
            handleSetSelectedPropertyPricesEditTransaction,
            phaseDataForm,
            handleSetPhaseDataInitialValues
        }),
        [
            entityAttachments,
            setEntityAttachments,
            clearEntityAttachments,
            entityNotes,
            setEntityNotes,
            clearEntityNotes,
            selectedPropertyPricesNewTransaction,
            handleSetSelectedPropertyPricesNewTransaction,
            selectedPropertyPricesEditTransaction,
            handleSetSelectedPropertyPricesEditTransaction,
            phaseDataForm,
            handleSetPhaseDataInitialValues
        ]
    );
    return <AimContext.Provider value={contextInterface}>{children}</AimContext.Provider>;
}

function useAimContext() {
    return useContext(AimContext);
}

export { useAimContext, AimProvider };
